<template>
  <div class="content">
    <div class="mainbox">
      <div class="topbox">
        <div></div>
        <div>
          <el-button :plain="radio3 != configData[0].type" type="primary" size="small"
            @click="getConfiguration(configData[0])">{{ configData[0].text }}</el-button>
          <el-button :plain="radio3 != configData[1].type" type="primary" size="small"
            @click="getConfiguration(configData[1])">{{ configData[1].text }}</el-button>
        </div>
      </div>
      <div class="inputbox">
        <div style="text-align: left;">
          <el-tag style="margin-right: 4px;" closable @close="handleClose(index)" v-for="(item, index) in tagList"
            :key="index">{{ item }}</el-tag>
        </div>

        <el-input v-model="expressNo" type="textarea" style="border: none;" :placeholder="configuration[1].content"
          :autosize="{ minRows: 3, maxRows: 6 }"></el-input>
        <div v-if="expressNo || tagList.length > 0" class="flexbox">
          <div>

          </div>
          <div>
            <el-button type="primary" size="small" plain icon="el-icon-delete" @click="clearFn">{{ configuration[2].content
            }}</el-button>
            <el-button type="primary" size="small" icon="el-icon-search" @click="submitFn">{{ configuration[3].content }}</el-button>
          </div>

        </div>

      </div>
      <div class="logbox" v-for="(item, index) in logisticsList" :key="index">
        <div class="flexbox2">
          <div>
            {{ configuration[4].content }} :{{ item.expressNumber }}
          </div>
          <div v-if="item.feedback != '订单不存在'">
            {{ configuration[5].content }} :{{ item.arrivalTime || '--' }}
          </div>
          <div style="display: flex;align-items: center;" v-if="item.feedback != '订单不存在'">
            <span>
              {{ configuration[6].content }} :{{ item.cabinetNumber || '--' }}
            </span>

            <i class="el-icon-caret-bottom" v-if="item.isOpen == true" @click="item.isOpen = false"></i>
            <i class="el-icon-caret-top" v-if="item.isOpen == false" @click="item.isOpen = true"></i>
          </div>
          <div v-if="item.feedback == '订单不存在'">
            {{ configuration[7].content }}
          </div>
        </div>
        <div v-if="item.isOpen == true && item.feedback != '订单不存在'">
        
          <div style="padding-top: 30px;padding-left: 30px;">
            <el-steps direction="vertical" :active="item.logisticsRecord.length - 1" space="100" finish-status="process">

              <el-step v-for="(etem, j) in item.logisticsRecord" :key="j" :title="etem.time"
                :description="etem.information"></el-step>
            </el-steps>

          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import {
  configData_api, getConfiguration_api, logisticsList_api
} from '@/api/interface'
import { Message, } from 'element-ui'
export default {
  name: 'HomeView',
  components: {

  },
  data() {
    return {
      configData: [{
        type: 1
      }, {
        type: 2
      }],
      radio3: '',
      configuration: [{
        content: ''
      }, {
        content: ''
      },
      {
        content: ''
      },
      {
        content: ''
      },
      {
        content: ''
      },
      {
        content: ''
      },
      {
        content: ''
      },
      {
        content: ''
      },
      ],
      tagList: [],
      expressNo: '',
      logisticsList: []



    };

  },
  created() {
    configData_api().then(res => {
      this.configData = res.data
      this.radio3 = this.configData[0].type
      this.getConfiguration(this.configData[0])
    })

  },
  mounted() {

  },
  methods: {
    getConfiguration(item) {
      getConfiguration_api(item.type).then(res => {
        this.radio3 = item.type
        this.configuration = res.data
      })
    },
    clearFn() {
      this.expressNo = ''
      this.tagList = []
    },
    submitFn() {
      if (this.expressNo) {
        this.tagList.push(this.expressNo)
        this.expressNo = ''
      }

      logisticsList_api({
        expressNo: this.tagList
      }).then(res => {
        this.logisticsList = res.data
        this.logisticsList.forEach(item => {
          this.$set(item, 'isOpen', true)
        })

      })

    },
    handleClose(index) {
      this.tagList.splice(index, 1)
    }

  }

}
</script>
<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  background: #f8f8f8;
}

.content {
  margin: 0;
  padding: 0;
  scrollbar-color: #e5e5e5 #f7f7f9;
  scrollbar-width: thin;
  min-height: 100vh;
  width: 100%;
  background: url(../assets/track_bg.48766fdd.jpg) no-repeat 50% / cover;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.mainbox {
  width: 100%;
  max-width: 1080px;
  min-height: 100vh;
  margin: 0 auto;
}

.topbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  padding-top: 15px;
}

.inputbox {
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(82, 87, 107, 0.11);
  transition: all .2s ease;
  width: 100%;
  min-width: 375px;
  min-height: 150px;
  box-sizing: border-box;

}

.logbox {
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(82, 87, 107, 0.11);
  transition: all .2s ease;
  width: 100%;
  min-width: 375px;

  box-sizing: border-box;
  margin-top: 15px;
}

.flexbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
}

.flexbox2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

}
</style>
<style>
.el-textarea__inner {
  border: none !important;
  background: none !important;
}

@media screen and (max-width: 600px) {
    .inputbox {
      width: 90% !important;
      margin: auto !important;
    }

    .logbox {
      width: 90% !important;
      margin: 15px auto !important;
    }
    .topbox{
      padding-right: 20px;
    }
  }
</style>
